import Draggable24 from '@carbon/icons-react/es/draggable/24';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { TaskType } from 'api/tasks';
import { ResourceSectionType } from 'data/documents';
import { selectActiveStatusUpdate } from 'data/status-updates';
import { useTasksByProjectId } from 'data/tasks/hooks/use-tasks-from-store';
import { useTranslation } from 'hooks/use-translation';
import { ApprovalCard } from './approval-card';
import { HighlightSection } from './highlight-section';
import styles from './status-update-highlights.module.css';

export const StatusUpdateHighlights = (): JSX.Element => {
  const { projectId } = useParams<{ projectId: string }>();
  const allProjectTasks = useTasksByProjectId(parseInt(projectId, 10));

  // There's no point in sending the private task in status updates as
  // the main consumer of status update is a customer
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);

  const projectTasks = activeStatusUpdate?.private
    ? allProjectTasks
    : allProjectTasks.filter((task) => !task.private);

  const normalTasks = projectTasks.filter(
    (task) => task.type !== TaskType.Milestone,
  );
  const milestones = projectTasks.filter(
    (task) => task.type === TaskType.Milestone,
  );

  const approvals = projectTasks.filter((task) => task.approvals?.length);

  const tasksLabel = useTranslation('tasks');
  const approvalsLabel = useTranslation('approvals');
  const milestonesLabel = useTranslation('milestones');

  return (
    <div className={styles.container}>
      <div className={styles.help}>
        <Draggable24 />
        <FormattedMessage id="status_updates.help" />
      </div>

      <HighlightSection
        config={{
          title: tasksLabel,
          type: ResourceSectionType.Task,
          tasks: normalTasks,
        }}
      />
      <HighlightSection
        config={{
          title: milestonesLabel,
          type: ResourceSectionType.Milestone,
          tasks: milestones,
        }}
      />
      <HighlightSection
        config={{
          title: approvalsLabel,
          type: ResourceSectionType.Approval,
          tasks: approvals,
        }}
        cardComponent={ApprovalCard}
      />
    </div>
  );
};
